import { getCsrfToken } from '@/integrations/php/client';
import type { ServiceType } from '@/context/LeadContext';

export interface PublicLeadResult {
  id: string;
  partnerId: string | null;
  capiToken: string;
}

export async function submitPublicLead(input: {
  name: string;
  phone: string;
  address: string;
  postalCode: string;
  service: ServiceType;
  timeframe: string;
  comments?: string;
  latitude?: number | null;
  longitude?: number | null;
  source?: string;
  campaign?: string | null;
}): Promise<PublicLeadResult | null> {
  const csrfToken = await getCsrfToken();
  const response = await fetch('/api/submit-web-lead.php', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({
      name: input.name,
      phone: input.phone,
      address: input.address,
      postal_code: input.postalCode,
      service: input.service,
      timeframe: input.timeframe,
      comments: input.comments ?? '',
      latitude: input.latitude ?? null,
      longitude: input.longitude ?? null,
      source: input.source ?? 'web',
      campaign: input.campaign ?? null,
    }),
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok || !body?.lead_id || !body?.capi_token) {
    return null;
  }

  return {
    id: body.lead_id,
    partnerId: body.partner_id ?? null,
    capiToken: body.capi_token,
  };
}
